import { createActions } from "redux-actions";

export const SET_HISTORY = "SET_HISTORY";
export const NAVIGATE_TO = "NAVIGATE_TO";
export const RENDER_AT_TOP = "RENDER_AT_TOP";
export const OPEN_QUOTE_POPUP = "OPEN_QUOTE_POPUP";
export const CLOSE_QUOTE_POPUP = "CLOSE_QUOTE_POPUP";
export const LOAD_PAGE = "LOAD_PAGE";
export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";
export const LOAD_DEFAULT_CHANNEL_DONE = "LOAD_DEFAULT_CHANNEL_DONE";
export const SET_QUERY_STRING = "SET_QUERY_STRING";
export const OPEN_APP_MODAL = "OPEN_APP_MODAL";
export const CLOSE_APP_MODAL = "CLOSE_APP_MODAL";

export const {
    setHistory,
    navigateTo,
    renderAtTop,
    openQuotePopup,
    closeQuotePopup,
    loadPage,
    showLoading,
    hideLoading,
    loadDefaultChannelDone,
    setQueryString,
    openAppModal,
    closeAppModal,
} = createActions(
    {
        [LOAD_PAGE]: (url, name, originalPathname) => ({
            url,
            name,
            originalPathname,
        }),
        [SHOW_LOADING]: message => ({
            show: true,
            message,
        }),
        [HIDE_LOADING]: () => ({
            show: false,
            message: null,
        }),
    },
    ...[
        SET_HISTORY,
        NAVIGATE_TO,
        RENDER_AT_TOP,
        OPEN_QUOTE_POPUP,
        CLOSE_QUOTE_POPUP,
        LOAD_DEFAULT_CHANNEL_DONE,
        SET_QUERY_STRING,
        OPEN_APP_MODAL,
        CLOSE_APP_MODAL,
    ]
);
